/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { BidBiddersControllerUpdateMutationRequest, BidBiddersControllerUpdateMutationResponse, BidBiddersControllerUpdatePathParams, BidBiddersControllerUpdate400, BidBiddersControllerUpdate401, BidBiddersControllerUpdate403, BidBiddersControllerUpdate404 } from "../../models/bidsController/BidBiddersControllerUpdate";

function getBidBiddersControllerUpdateUrl(id: BidBiddersControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/bidders/${id}` as const }  
  return res
}

/**
 * @summary Rename a trade partner, or withdraw them or undo it
 * {@link /api/v1/bidders/:id}
 */
export async function bidBiddersControllerUpdate(id: BidBiddersControllerUpdatePathParams["id"], data?: BidBiddersControllerUpdateMutationRequest, config: Partial<RequestConfig<BidBiddersControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<BidBiddersControllerUpdateMutationResponse, ResponseErrorConfig<BidBiddersControllerUpdate400 | BidBiddersControllerUpdate401 | BidBiddersControllerUpdate403 | BidBiddersControllerUpdate404>, BidBiddersControllerUpdateMutationRequest>({ method : "PATCH", url : getBidBiddersControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}